import isMobile from 'piramis-js-utils/lib/isMobile'

export function tooltipTrigger() {
  return isMobile() ? 'click' : 'hover'
}
